import { render, staticRenderFns } from "./duo_experiment_beta_features_form.vue?vue&type=template&id=8293a0e4"
import script from "./duo_experiment_beta_features_form.vue?vue&type=script&lang=js"
export * from "./duo_experiment_beta_features_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports